import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { UserService } from '../../user/user.service';
import { UserRole } from '../../user/user.types';

/**
 * Gates a route behind one or more roles, set via
 * `data: { requiredRoles: ['Admin', 'Crm'] }`.
 * Runs after `AuthGuard`, so it only has to compare roles, not check auth.
 *
 * There's no "not authorized" page, so a mismatch redirects home rather than
 * dead-ending the user - same fallback the wildcard route already uses.
 */
export const RoleGuard: CanActivateFn | CanActivateChildFn = (route) => {
  const router: Router = inject(Router);
  const requiredRoles = route.data?.['requiredRoles'] as UserRole[] | undefined;

  if (!requiredRoles?.length) return true;

  return inject(UserService).user$.pipe(
    take(1),
    map((user) =>
      user && requiredRoles.includes(user.role)
        ? true
        : router.parseUrl('tenders'),
    ),
  );
};
